export class Distributor {
    public id: string;
    public name: string;
    public phoneNumber: string;

    constructor();
    constructor(json: any)
    constructor(json?: Distributor) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.phoneNumber = json.phoneNumber;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/distributor.ts